var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        { attrs: { titulo: "Editar " }, on: { cerrar: _vm.handleCerrar } },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "boton_crear", staticStyle: { height: "37px" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "icon",
                      staticStyle: {
                        "background-color": "rgb(255, 108, 0)",
                        "border-color": "rgb(255, 108, 0)",
                        "padding-right": "20px",
                        display: "block",
                        margin: "0 0 0 auto"
                      },
                      on: { click: _vm.EditarBaja }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "color-blanco",
                          staticStyle: { color: "white" }
                        },
                        [_vm._v("Guardar Cambios")]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            { attrs: { md10: "" } },
            [
              _c(
                "v-card",
                { staticClass: "rounded-card" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "col-md-12",
                      attrs: { "lazy-validation": "" }
                    },
                    [
                      _c(
                        "v-container",
                        {
                          staticStyle: { padding: "30px 40px 50px 40px" },
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "FormFieldsContainer",
                            { attrs: { titulo: "Motivo de baja SIM" } },
                            [
                              _vm._t("prependInformacionGeneral"),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { display: "none" },
                                  attrs: { xs4: "", sm4: "", md4: "" }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.Id.label,
                                      disbaled: ""
                                    },
                                    model: {
                                      value: _vm.formFields.Id.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.Id,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.Id.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.Motivo.label,
                                      disabled: _vm.estado == "INACTIVO"
                                    },
                                    model: {
                                      value: _vm.formFields.Motivo.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.Motivo,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.Motivo.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.FechaActual.label,
                                      disabled: ""
                                    },
                                    on: { change: _vm.fechaMaxima },
                                    model: {
                                      value: _vm.formFields.FechaActual.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.FechaActual,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.FechaActual.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-combobox", {
                                    attrs: {
                                      label: _vm.formFields.estado.label,
                                      items: _vm.Listaestado
                                    },
                                    model: {
                                      value: _vm.formFields.estado.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.estado,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.estado.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }